import SuccessDialog from './SuccessDialog';

export default SuccessDialog;
export * from './SuccessDialog';
